import { useContext } from 'react';

import HomePageSectionContext from './HomePageSectionContext';

/**
 * A hook to retrieve home page section information.
 */
const useHomePageSection = () => useContext(HomePageSectionContext);

export default useHomePageSection;
